import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generateOneLinkUrl } from '@cian/appsflyer-onelink';

import { hideUnsupportedModal } from '../../actions/folders/actions';
import { FoldersUnsupportedModal } from '../../components/FoldersUnsupportedModal';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { selectIsFoldersUnsupportedModalOpen } from '../../selectors/folders';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackClickOnBanner, trackShowBanner } from './tracking';
import { MOBILE_APP_UNSUPPORTED_BANNER_TITLE, downLoadUrl } from './constants';

export const FoldersUnsupportedModalContainer = () => {
  const {
    config,
    custom: { platform },
  } = useApplicationContext();
  const dispatch = useDispatch();
  const isOpenByApp = useSelector(selectIsFoldersUnsupportedModalOpen);
  const [isHidedByUser, saveModalHideState] = useLocalStorage('isFolderUnsupportedModalHide', false);
  const [mobileBannerDownloadUrl, setMobileBannerDownloadUrl] = React.useState<string | null>(downLoadUrl);
  const isHiddenByConfig = config.get('favorites-frontend.isFolderUnsupportedModalHidden') || false;
  // by app - это когда мы зашли на страницу подборки, в таком случае мы точно показываем модалку
  // by user - это когда юзер закрыл модалку в этой или прошлой сессии
  // by config - фиче-тоггл, который полностью включает/отключает функционал
  const isOpen = (isOpenByApp || !isHidedByUser) && !isHiddenByConfig;

  React.useEffect(() => {
    if (isOpen) {
      setMobileBannerDownloadUrl(
        generateOneLinkUrl(mobileBannerDownloadUrl, 'mobile_site', MOBILE_APP_UNSUPPORTED_BANNER_TITLE),
      );
      trackShowBanner(platform);
    }
  }, [isOpen]);

  const handleModalClose = React.useCallback(() => {
    saveModalHideState(true);
    dispatch(hideUnsupportedModal());
  }, [saveModalHideState, dispatch]);

  const handleButtonClick = React.useCallback(() => {
    trackClickOnBanner(platform);
  }, []);

  return (
    <FoldersUnsupportedModal
      url={mobileBannerDownloadUrl || ''}
      isOpen={isOpen}
      onClose={handleModalClose}
      onClick={handleButtonClick}
    />
  );
};
